// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.vendor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.add-material-btn {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.add-material-btn:hover {
  background-color: #45a049;
}

/* Tables */
.vendor-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.vendor-table th,
.vendor-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.vendor-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.vendor-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.vendor-table tr:hover {
  background-color: #f1f1f1;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.view-btn,
.payment-btn,
.delete-btn {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.view-btn {
  background-color: #2196f3;
  color: white;
}

.view-btn:hover {
  background-color: #0b7dda;
}

.payment-btn {
  background-color: #ff9800;
  color: white;
}

.payment-btn:hover {
  background-color: #e68a00;
}

.delete-btn {
  background-color: #f44336;
  color: white;
}

.delete-btn:hover {
  background-color: #da190b;
}

.no-data {
  text-align: center;
  color: #666;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.bill-modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 95%;
  /* max-width: 1000px; */
  height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.modal-header h3 {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.close-btn:hover {
  color: #333;
}

.modal-actions {
  display: flex;
  gap: 10px;
}

.add-payment-btn {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.add-payment-btn:hover {
  background-color: #45a049;
}

.print-btn {
  background-color: #2196f3;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.print-btn:hover {
  background-color: #0b7dda;
}

/* Form Styles */
.material-form,
.payment-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-weight: bold;
}

.form-group input,
.form-group select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.submit-btn {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
}

.submit-btn:hover {
  background-color: #45a049;
}

/* Bill Details */
.bill-details {
  margin-top: 20px;
}

.bill-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.bill-info p {
  margin: 5px 0;
}

.materials-table,
.payments-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
}

.materials-table th,
.materials-table td,
.payments-table th,
.payments-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.materials-table th,
.payments-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.edit-btn {
  background-color: #2196f3;
  color: white;
  border: none;
  padding: 10px 17px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.edit-btn:hover {
  background-color: #0b7dda;
}

.delete-btn {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 10px 17px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/material/singlevendor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".vendor-container {\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.vendor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.add-material-btn {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.add-material-btn:hover {\n  background-color: #45a049;\n}\n\n/* Tables */\n.vendor-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.vendor-table th,\n.vendor-table td {\n  border: 1px solid #ddd;\n  padding: 12px;\n  text-align: left;\n}\n\n.vendor-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.vendor-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.vendor-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.view-btn,\n.payment-btn,\n.delete-btn {\n  padding: 6px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.view-btn {\n  background-color: #2196f3;\n  color: white;\n}\n\n.view-btn:hover {\n  background-color: #0b7dda;\n}\n\n.payment-btn {\n  background-color: #ff9800;\n  color: white;\n}\n\n.payment-btn:hover {\n  background-color: #e68a00;\n}\n\n.delete-btn {\n  background-color: #f44336;\n  color: white;\n}\n\n.delete-btn:hover {\n  background-color: #da190b;\n}\n\n.no-data {\n  text-align: center;\n  color: #666;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 80%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.bill-modal-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 95%;\n  /* max-width: 1000px; */\n  height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.modal-header h3 {\n  margin: 0;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n}\n\n.close-btn:hover {\n  color: #333;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.add-payment-btn {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.add-payment-btn:hover {\n  background-color: #45a049;\n}\n\n.print-btn {\n  background-color: #2196f3;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.print-btn:hover {\n  background-color: #0b7dda;\n}\n\n/* Form Styles */\n.material-form,\n.payment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.form-group label {\n  font-weight: bold;\n}\n\n.form-group input,\n.form-group select {\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.submit-btn {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 10px;\n}\n\n.submit-btn:hover {\n  background-color: #45a049;\n}\n\n/* Bill Details */\n.bill-details {\n  margin-top: 20px;\n}\n\n.bill-info {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n}\n\n.bill-info p {\n  margin: 5px 0;\n}\n\n.materials-table,\n.payments-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 15px 0;\n}\n\n.materials-table th,\n.materials-table td,\n.payments-table th,\n.payments-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: left;\n}\n\n.materials-table th,\n.payments-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.edit-btn {\n  background-color: #2196f3;\n  color: white;\n  border: none;\n  padding: 10px 17px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.edit-btn:hover {\n  background-color: #0b7dda;\n}\n\n.delete-btn {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 17px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
